import { isDark } from '@/utils/utils';
import { Stack, Typography, useTheme } from '@mui/material';

interface Props {
  text?: string
}

export default function Empty(props: Props) {
  const theme = useTheme();
  const dark = isDark(theme);

  return <Stack direction="column" justifyContent="center" alignItems="center" gap={'5px'} sx={{minHeight:'400px'}}>
    {/* <RpIcon icon="box" size={55}/> */}
    {<img src={`/images/common/empty${dark ? '-dark' : ''}.svg`} width={75} />}
    {props.text && <Typography color="text.secondary">{props.text}</Typography>}
  </Stack>
}